import { render, staticRenderFns } from "./KliringVAPangkalanLPG.vue?vue&type=template&id=c978068a"
import script from "./KliringVAPangkalanLPG.vue?vue&type=script&lang=js"
export * from "./KliringVAPangkalanLPG.vue?vue&type=script&lang=js"
import style0 from "./KliringVAPangkalanLPG.vue?vue&type=style&index=0&id=c978068a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports